import { decodeHTML } from 'entities'
const renderSpecialCharacters = (string: string) => {
  return decodeHTML(string)
}

export default renderSpecialCharacters
